/* Sherry's Wardrobe — occasion slider. Scoped, editor-safe, progressive. */
(() => {
  const init = (root) => {
    if (!root || root.dataset.swoBound === 'true') return;
    root.dataset.swoBound = 'true';
    const track = root.querySelector('[data-swo-track]');
    if (!track) return;
    const cards = Array.from(track.querySelectorAll('[data-swo-card]'));
    const previous = root.querySelector('[data-swo-prev]');
    const next = root.querySelector('[data-swo-next]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const updateControls = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const x = track.scrollLeft;
      if (previous) previous.disabled = x <= 3;
      if (next) next.disabled = x >= maxScroll - 3;
    };
    const scrollCard = (direction) => {
      if (!cards.length) return;
      const current = track.scrollLeft;
      const positions = cards.map((card) => card.offsetLeft - cards[0].offsetLeft);
      const nextIndex = direction > 0
        ? positions.findIndex((x) => x > current + 5)
        : positions.map((x, i) => ({ x, i })).filter((p) => p.x < current - 5).at(-1)?.i ?? 0;
      const chosen = direction > 0 ? (nextIndex === -1 ? cards.length - 1 : nextIndex) : nextIndex;
      track.scrollTo({ left: positions[chosen], behavior: reduced ? 'auto' : 'smooth' });
    };
    if (previous) previous.addEventListener('click', () => scrollCard(-1));
    if (next) next.addEventListener('click', () => scrollCard(1));
    track.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
    const animated = Array.from(root.querySelectorAll('[data-swo-animate]'));
    if (reduced || !('IntersectionObserver' in window) || window.Shopify?.designMode) {
      animated.forEach((el) => el.classList.add('swo-visible'));
    } else {
      root.classList.add('swo-js');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('swo-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.07, rootMargin: '0px 0px -20px 0px' });
      animated.forEach((el) => observer.observe(el));
    }
  };
  const initAll = (node = document) => {
    if (node.matches?.('[data-swo-section]')) init(node);
    node.querySelectorAll?.('[data-swo-section]').forEach(init);
  };
  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest?.('[data-swo-card]');
    if (card) card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  });
})();
